<template>
  <div v-if="db">
    <!--Header Banner Content Start-->
    <section class="tj-banner-form">
      <div class="container">
        <div class="row">
          <!--Header Banner Caption Content Start-->
          <div class="col-md-8 col-sm-7" v-if="db.MainBanner">
            <div class="banner-caption">
              <div class="banner-inner bounceInLeft animated delay-2s" :class="{ 'top6':activeTab=='one-way', 'top12':activeTab=='two-way',}">
                <h2>{{db.productInfo.name}}</h2>
                <h4>{{db.MainBanner.strong}} <br/> {{db.MainBanner.title}}</h4>
                <div class="banner-btns">
                  <a :href="db.MainBanner.iosAppUrl" class="btn-style-1">
                    <i class="fab fa-apple"></i> Download App
                  </a>
                  <a :href="db.MainBanner.androidAppUrl" class="btn-style-2">
                    <i class="fab fa-android"></i> Download App
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tj-mobile-image"  :class="{ 'oneWayImage':activeTab=='one-way', 'twoWayImage':activeTab=='two-way',}"></div>

          <!--Header Banner Caption Content End-->
          <bookingTab @onTabChange="tabChanged" />
        </div>
      </div>
    </section>
    <!--Header Banner Content End-->

    <!--Offer Content Start-->
    <section class="tj-offers">
      <div class="row">
        <!--Offer Box Content Start-->
        <div class="col-md-3 col-sm-6" v-for="(cn,key) in db.offerBoxContent" :key="key">
          <div class="offer-box">
            <img :src="cn.imageUrl" alt />
            <div class="offer-info">
              <h4>{{cn.title}}</h4>
              <!-- <p>{{cn.description}}</p> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Offer Content End-->
    <about-us :data="db.WhoWeAre" />

    <fleets :data="db.fleet" :db="db" />

    <services :data="db.services" :sd="db.serviceDescription" />
  </div>
</template>

<script>
import firebase from "firebase";
import AboutUs from "./AboutUs";
import Fleets from "./Fleets";
import Services from "./Services";
import bookingTab from "./bookings/bookingTab";
export default {
  name: "Home",
  components: {
    AboutUs,
    Fleets,
    Services,
    bookingTab
  },
  data() {
    return {
      db: null,
      activeTab:'one-way'
    };
  },
  created() {
    let that = this;
    var ref = firebase.database().ref();
    ref.on(
      "value",
      function(snapshot) {
        that.db = snapshot.val();
        // // console.log(snapshot.val());
      },
      function(error) {
        // console.log("Error: " + error.code);
      }
    );
  },
  methods: {
    tabChanged(id) {
      this.activeTab=id;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
